import { IUser } from 'models';
import { Moment } from 'moment';
import { IContact } from './contact';
import { IExpense } from './expenses';
import { IAttachment } from './attachment';
import { RateType } from './rate';

export enum ShiftAction {
  Invoice = 'Invoice',
}

export interface IShift {
  // key: number;
  id: string;
  idAssignee: string;
  assignee: IUser;
  contact: IContact;
  summary: string;
  comments: string;
  notes: string;
  client: string;
  endDate: Moment;
  startDate: Moment;
  duration: number;
  location: string;
  rate: string;
  expenses?: IExpense[];
  completed: boolean;
  category: string;
  idRate: string;
  rateAmountExclGst: number;
  rateName: string;
  rateType: RateType;
  totalExclGst: number;
  totalInclGst: number;
  expanded: boolean;
  shiftStatus: ShiftStatus;
  isComplete: boolean;
  isDuplicate: boolean;
  idContact?: string;
  idInvoice?: string;
  tz: string;
  isGstFree?: boolean;
  attachments?: IAttachment[];
  recurrenceRule?: string;
  incidentsCount: number;
}

export interface CompleteShift {
  id: string;
  isGstFree: boolean;
}

export interface IShiftCancel {
  id: string;
  cancellationReason: string;
  cancellationAmountExclGst: number;
  isGstFree: boolean;
}

export enum DeleteShiftType {
  Single = 'single',
  Future = 'future',
  All = 'all',
}

export enum ShiftStatus {
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  Completed = 'Completed',

  // Not persistent
  Today = 'Today',
  All = 'All statuses',
  NotInvoiced = 'Not invoiced',
}

export enum ShiftCategory {
  AssistanceDailyLife = 'Assistance with daily life',
  AssistanceSocialCommunity = 'Assistance with social and community participation',
  Transport = 'Transport',
  SupportCoordination = 'Support Coordination',
  IncreasedSocialcommunity = 'Increased social and community participation',
  FindingKeepingJob = 'Finding and keeping a job',
}
